<template>
  <div
    v-if="isLogin && this.$route.name !== 'project-list'"
    class="tools-container">
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.search
        }
      ]"
      @click="handleSearchClick"
    >
      <el-tooltip content="搜索" placement="bottom">
        <img :src="SerachIcon" />
      </el-tooltip>
    </div>
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.marker
        }
      ]"
      @click="handleToolClick('point')"
    >
      <el-tooltip content="点位" placement="bottom">
        <img :src="PointIcon" />
      </el-tooltip>
    </div>
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.rectangle
        }
      ]"
      @click="handleToolClick('rect')"
    >
      <el-tooltip content="矩形区域" placement="bottom">
        <img :src="RectIcon" />
      </el-tooltip>
    </div>
    <div
      :class="[
        'item',
        {
          'is-active': UIStatus.polygon
        }
      ]"
      @click="handleToolClick('polygon')"
    >
      <el-tooltip content="多边形区域" placement="bottom">
        <img :src="PolyIcon" />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import SerachIcon from './images/tool_01.png';
import PointIcon from './images/tool_02.png';
import RectIcon from './images/tool_03.png';
import PolyIcon from './images/tool_04.png';
import newFarm from './images/tool_05.png';
import ImportIcon from './images/tool_06.png';
import { mapGetters } from 'vuex';

export default {
  props: {
    UIStatus: {
      type: Object,
      default: () => {
        return {
          search: false,
          marker: false,
          rectangle: false,
          polyline: false,
          newFarm: false,
          importFarm: false
        };
      }
    }
  },
  data() {
    return {
      SerachIcon,
      ImportIcon,
      PointIcon,
      RectIcon,
      PolyIcon,
      newFarm
    };
  },
  methods: {
    handleNewWindFarmClick() {
      this.$emit('newWindFarm');
    },
    importFile() {
      this.$emit('importFile');
    },
    handleSearchClick() {
      this.$emit('seachClick');
    },
    handleToolClick(type) {
      this.$emit('mapToolClick', type);
    }
  },
  computed: {
    ...mapGetters(['isLogin'])
  }
};
</script>

<style lang="less" scoped>
.tools-container {
  position: absolute;
  top: 4px;
  height: 50px;
  right: 5px;
  background-color: #c8e0f5;
  z-index: 500;
  display: flex;
  box-shadow: 0px 0px 2px #aaa;
  border-radius: 10px;
  align-items: center;
  padding: 0px 10px;

  .item {
    height: 48px;
    width: 48px;
    margin-right: 5px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
    user-select: none;
    padding: 10px;
    border-radius: 10px;

    &.is-active {
      background-color: #d9e6f3;
    }
    img {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
